CF.ready(function(){

    gsap.registerPlugin(ScrollToPlugin);

    // header button create task

    const buttonCreateTaskMobile = document.querySelector('.header-mobile-bottom .header-create-task a');

    buttonCreateTaskMobile.addEventListener('click', (e) => {
        e.preventDefault();
        closeHeaderMobile();
    })

    function closeHeaderMobile(){
        headerMobileContainer.classList.remove('active');
        headerMobileContainer.classList.add('not-active');
        menuBtn.classList.remove('active');
        showMenu = false;
        document.body.style.height = 'auto';
        document.body.style.overflow = 'unset';
    }

    // FRONT CUSTOM

    // const cfFormCustomLoader = document.querySelectorAll('.cf-custom-loader');

    // setTimeout(() => {
    //     cfFormCustomLoader.forEach(loader => {
    //         loader.classList.remove('active');
    //     })
    // }, 5000);

    // labels custom
    const labels = document.querySelectorAll('.cf-field.boutique-shopify label, .cf-field.create-account label, .cf-field[data-cf-field-id="978737"] label');
    for(label of labels){
        const emptySquare = document.createElement('div');
        const greenSquare = document.createElement('div');

        emptySquare.prepend(greenSquare);
        label.append(emptySquare);
    }

    const labelTermAndConditions = document.querySelector('.cf-field.create-account label > span');

    const divUrlDataCGV = document.querySelector('.cgv-url-data')

 labelTermAndConditions.removeAttribute('aria-hidden');

    labelTermAndConditions.innerHTML = `${divUrlDataCGV.dataset.cgvTitleOne} <a href="${divUrlDataCGV.dataset.cgvLink}" target="_blank" class="hover-green" style="text-decoration:underline; text-underline-offset:2px; color:#000">${divUrlDataCGV.dataset.cgvTextLink}</a>${divUrlDataCGV.dataset.cgvTitleTwo}`

    
    // FORM CF CUSTOM

    let myForm = document.querySelector('form[data-cf-form]')
    let cfForm = myForm.cfForm;
    let firstName = '';
    let lastName = '';
    

    let validationUsername = {
        comparator: function isValid(fieldValue){
            if(fieldValue.match(/^([a-zA-Z0-9 _-]+)$/)){
                return true;
            } else{
                return false;
            }
        },

        errorMessage:'Le nom d\'utilisateur est composé uniquement de lettres majuscules et/ou minuscules et/ou de chiffres.'
    }

    let validationEmail = {
        comparator:function isValid(fieldValue){
            if(fieldValue.match(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)){
                return true;
            } else{
                return false;
            }
        },

        errorMessage:errorFieldError
    }

    let validationURL = {
        comparator:function isValid(fieldValue){
            if(fieldValue.match(/[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)?/gi)){
                return true;
            } else{
                return false;
            }
        },

        errorMessage:"Le format de l'url est invalide"
    }
    
    cfForm.addValidator(validationUsername, 'nom_dutilisateur')
    cfForm.addValidator(validationEmail, 'email')
    cfForm.addValidator(validationURL, 'url_de_votre_boutique_shop')

     myForm.addEventListener('cf:field_changed', function(event) {
        var fieldId = event.detail.fieldId;
        var columnKey = event.detail.columnKey;
        var value = event.detail.value;
        if(columnKey =='last_name') {
          lastName = value;
        }
        if(columnKey =='first_name') {
          firstName = value;
        }
        // -> 897424, "favorite_color", "Blue", <div class="cf-field" data-cf-field-id="897424">
      });


    myForm.addEventListener('cf:field_validated', function(event) {
        let errors = event.detail.errors;

        if(errors.length === 0){
            event.target.classList.add('valid');
        } else{
            event.target.classList.remove('valid');

            if(document.getElementById('email-exist-error')){
                const errorEmailAlreadyExists = document.getElementById('email-exist-error');
                errorEmailAlreadyExists.style.display = "none";
            }
        }
      });


    // select custom CF

    initHtmlSelectCustomCF();

    const fieldContainer = document.querySelector('.cf-field.deadline-choice');
    

    function initHtmlSelectCustomCF(){
        const legendTag = document.querySelector('.cf-field.deadline-choice legend');

        legendTag.insertAdjacentHTML('afterend', '<div class="select-custom-container"></div>');

        const selectCustomContainer = document.querySelector('.select-custom-container');
    
        const allOptions = document.querySelectorAll('.cf-field.deadline-choice .cf-enum-field__choice');
    
        const titleFirst = document.createElement('div');
        titleFirst.classList.add('select-custom-title-first');
        titleFirst.innerHTML = `<span>${customTitleFirst}</span>`;

        const svgChevronContainer = document.createElement('div');
        svgChevronContainer.classList.add('svg-chevron');
        svgChevronContainer.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="16.943" height="11.3" viewBox="0 0 16.943 11.3">
        <path id="Tracé_13893" data-name="Tracé 13893" d="M0,0,7.057,7.057,0,14.114" transform="translate(15.528 1.414) rotate(90)" fill="none" stroke="#65d09a" stroke-miterlimit="10" stroke-width="4"/>
        </svg>`;

        titleFirst.append(svgChevronContainer);
        selectCustomContainer.prepend(titleFirst);

        titleFirst.addEventListener('click', () => {
            fieldContainer.classList.toggle('active');

            // titleFirst.classList.add('first-click');

            const titleFirstSpan = titleFirst.querySelector('span');
            let spanTitleFirstText;

            if(fieldContainer.classList.contains('active')){
                spanTitleFirstText = customTitleFirst
            } else{
                if(selectCustomContainer.classList.contains('checked-within')){
                    const activeOptionText = document.querySelector('.cf-field.deadline-choice .cf-enum-field__choice input:checked + span');

                    spanTitleFirstText = activeOptionText.innerText;
                } else{
                    spanTitleFirstText = customTitleFirst;
                }
            }

            titleFirstSpan.innerText = spanTitleFirstText;

        })

        for(option of allOptions){
            selectCustomContainer.appendChild(option);

            option.addEventListener('click', function(e){
                if(e.target.type == 'radio'){


                    titleFirst.innerHTML = `<span>${e.target.value}</span><div class="svg-chevron"><svg xmlns="http://www.w3.org/2000/svg" width="16.943" height="11.3" viewBox="0 0 16.943 11.3">
                    <path id="Tracé_13893" data-name="Tracé 13893" d="M0,0,7.057,7.057,0,14.114" transform="translate(15.528 1.414) rotate(90)" fill="none" stroke="#65d09a" stroke-miterlimit="10" stroke-width="4"/>
                    </svg></div>`;
                    fieldContainer.classList.remove('active');

                    const fieldSet = document.querySelector('.cf-field.deadline-choice fieldset');

                    fieldSet.classList.add('active');
                    selectCustomContainer.classList.add('checked-within');
                }

                
            })
        }
    }

    // step 2

    myForm.addEventListener('cf:form_submitted', function() {
        const headerContainer = document.querySelector('.header-container')
        const verifyContainer = document.querySelector('.cf-verify-email-message');
        verifyContainer.setAttribute('id','verify-email-message');
        const verifyDescription = document.createElement('p');
        verifyDescription.innerText = headerContainer.dataset.cfVerify;

        const svgIconVerify = document.createElement('div');
        svgIconVerify.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="74.858" height="68.052" viewBox="0 0 74.858 68.052">
        <path id="icons8-search-in-mail" d="M8.805,4A6.8,6.8,0,0,0,2,10.805V51.637a6.8,6.8,0,0,0,6.805,6.805H33.587a24.416,24.416,0,0,1-.964-6.805H8.805V21.02L36.026,38.026l13.5-8.434L63.247,21.02v7.762a23.538,23.538,0,0,1,6.805,3.2V10.805A6.8,6.8,0,0,0,63.247,4H8.805Zm0,6.805H63.247v3.409L36.026,31.221,8.805,14.215ZM56.442,34.624a17.013,17.013,0,0,0,0,34.026,18.3,18.3,0,0,0,9.53-2.725l6.121,6.127,4.765-4.765L70.73,61.167a18.3,18.3,0,0,0,2.725-9.53A16.848,16.848,0,0,0,56.442,34.624Zm0,6.805A10.208,10.208,0,1,1,46.234,51.637,10.026,10.026,0,0,1,56.442,41.429Z" transform="translate(-2 -4)" fill="#23d396"/>
        </svg>`;

        verifyContainer.appendChild(verifyDescription);
        verifyContainer.appendChild(svgIconVerify);

        const stepOne = document.querySelector('.list-steps.not-connected li:nth-child(1)');
        const stepTwo = document.querySelector('.list-steps.not-connected li:nth-child(2)');
        const arrowRight = document.querySelector('.list-steps.not-connected li svg');

        stepOne.classList.add('done');
        stepTwo.classList.add('active');
        stepTwo.appendChild(arrowRight);

        gsap.to(window, {duration:0.6, scrollTo:{y:'#verify-email-message', offsetY:350}});

    });

    // email already exists

    myForm.addEventListener('cf:form_submission_failed', function(event) {

        let errors = event.detail.errors;

        if(errors.email){


            if(document.getElementById('email-exist-error')){
                const errorEmailAlreadyExists = document.getElementById('email-exist-error');
                errorEmailAlreadyExists.style.display = "block";
            }
            else{
                const cfFieldMail = document.querySelector('.cf-field[data-cf-field-type="email"]');
                const headerContainer = document.querySelector('.header-container')

                const errorList = document.createElement('ul');
                errorList.classList.add('cf-field-errors');
                errorList.setAttribute('id', 'email-exist-error');
                const errorLi = document.createElement('li');
                const divError = document.createElement('div')
                divError.innerHTML = `${headerContainer.dataset.cfEmailExist1}<span id="connect-email-exist">${headerContainer.dataset.cfEmailExistLink}</span>${headerContainer.dataset.cfEmailExist2}`;
                divError.innerHTML = emailAlreadyBeen+'<span id="connect-email-exist">'+LoginLinkEmail+'</span>.';

                errorLi.appendChild(divError);
                errorList.appendChild(errorLi);
                cfFieldMail.appendChild(errorList);

                const connectEmailExist = document.querySelector('#connect-email-exist');

                connectEmailExist.addEventListener('click', () => {
                    const accountContainer = document.querySelector('.account-container');
                    const menuBtn = document.querySelector('.menu-btn');
                
                    // desktop
                    accountContainer.classList.add('active');

                    // mobile/tablet
                    setTimeout(() => {
                        if(screen.width <= 989 || window.innerWidth <= 989){
                            menuBtn.click();
                        }
                    }, 300);

                    gsap.to(window, {duration:0.4, scrollTo:{y:"#shopify-section-header"}});
                })
            }

            gsap.to(window, {duration:0.6, scrollTo:{y:'#email-exist-error', offsetY:200}});
        }
    });

    // scroll to first error

    const CFFormBtnSubmit = document.querySelector('.cf-form-actions button[type="submit"]')

  function makeid(length) {
      let result = '';
      const characters = '0123456789';
      const charactersLength = characters.length;
      let counter = 0;
      while (counter < length) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
        counter += 1;
      }
      return result;
    }

    CFFormBtnSubmit.addEventListener('click', () => {
        userNamevalue = firstName+lastName;
        if(userNamevalue.length > 12) {
          userNamevalue = userNamevalue.slice(0, 8);
          var randomNumbers = makeid(4);
          var randomPadding = randomNumbers
          userNamevalue = userNamevalue+randomPadding;
        }else if(userNamevalue.length < 8) {
          var lengthRemain = 8 - userNamevalue.length;
          var randomNumbers = makeid(lengthRemain);
          var randomPadding = randomNumbers;
          userNamevalue = userNamevalue+randomPadding;
        }
        
        myForm.cfForm.setFieldValue('nom_dutilisateur', userNamevalue);
        setTimeout(() => {
            const firstInvalidField = document.querySelector('.cf-field[data-cf-invalid="true"]');

            gsap.to(window, {duration:0.3, scrollTo:{y:firstInvalidField, offsetY:250}});
        }, 200);
    })

    // Form NO CF

    if(window.location.search.includes('?contact_posted=true')){
        const stepOne = document.querySelector('.list-steps.connected li:nth-child(1)');
        const stepTwo = document.querySelector('.list-steps.connected li:nth-child(2)');
        const arrowRight = document.querySelector('.list-steps.connected li svg');

        stepOne.classList.add('done');
        stepTwo.classList.add('active');
        stepTwo.appendChild(arrowRight);

        gsap.to(window, {duration:0.6, scrollTo:{y:'#ct-success', offsetY:250}});

        // mobile

        const formNOCF = document.querySelector('#contact_form')

        formNOCF.classList.add('posted');

        const stepFollowConnected = document.querySelector('.steps-mobile.connected .step:nth-child(1)');
        const firstStepMobile = document.querySelector('.step.first-step');
        const successContainerMobile = document.querySelector('.success-container.mobile');

        successContainerMobile.classList.add('active');

        firstStepMobile.classList.add('done');

        stepFollowConnected.classList.add('active');

    }
    else{
        const formNOCFBtn = document.querySelector('#contact_form button[type="submit"]');

        const allTextFields = document.querySelectorAll('.ct-field.text-field');
        const radioFields = document.querySelectorAll('.ct-field.radio-field');

        const radioShopifyExist = document.querySelectorAll('.radio-block input');
        const inputShopifyURL = document.querySelector('#shopify-url')
        const inputShopifyURLError = document.querySelector('#shopify-url + .ct-errors')

        formNOCFBtn.addEventListener('click', (e) => {

            for(field of allTextFields){
                const input = field.querySelector('input[type="text"]') ?? field.querySelector('input[type="email"]') ?? field.querySelector('textarea');
        
                const error = field.querySelector('.ct-errors.text');

                displayTextError(input, error, 'blur');
            }

            for(field of radioFields){
                displayRadioError(field)
            }

            if(inputShopifyURL.dataset.active === "false"){
                inputShopifyURLError.innerHTML = "";
            }

            if(!checkAllErrors()){
                e.preventDefault();

                const firstError = document.querySelector('.ct-errors[data-error="true"]')

                gsap.to(window, {duration:0.3, scrollTo:{y:firstError, offsetY:250}});
            } else{
                const loader = document.querySelector('.ct-form-loader')
                loader.classList.add('active');

                // const inputCompanyValue = document.querySelector('input[name="contact[company]"]').value;

                // if(inputCompanyValue !== ""){
                //     CF.customer.set("default_address", {
                //         company:inputCompanyValue
                //     });
                //     CF.customer.save();
                // }
            }

        })

        function checkAllErrors(){
            let formIsValid = true;
            const allErrors = document.querySelectorAll('.ct-errors')

            allErrors.forEach(error => {
                if(error.dataset.error === "true"){
                    formIsValid = false;
                };
            })

            return formIsValid;
        }
        

        for(field of allTextFields){
            const input = field.querySelector('input[type="text"]') ?? field.querySelector('input[type="email"]') ?? field.querySelector('textarea');

            const error = field.querySelector('.ct-errors.text');

            input.addEventListener('blur', () => {
                displayTextError(input, error, 'blur')
            })

            input.addEventListener('input', () => {
                displayTextError(input, error, 'input')
            })
        }

        for(radio of radioShopifyExist){
            radio.addEventListener('change', (e) => {
                if(e.target.value === 'exist'){
                    inputShopifyURL.dataset.active = "true";
                    inputShopifyURL.dataset.error = "";
                    inputShopifyURLError.dataset.error = "";
                } else if(e.target.value === 'no_exist'){
                    inputShopifyURL.dataset.active = "false";
                    inputShopifyURL.dataset.error = "false";
                    inputShopifyURLError.dataset.error = "false";
                    inputShopifyURL.value = "";
                    inputShopifyURLError.innerHTML = "";
                }
            })
        }

        function displayRadioError(field){
            const errorDiv = field.querySelector('.ct-errors')
            const allRadioInputs = field.querySelectorAll('input[type="radio"]');
            const inputChecked = field.querySelector('input:checked');

            allRadioInputs.forEach(input => {
                input.addEventListener('change', () => {
                    errorDiv.innerHTML = "";
                    errorDiv.dataset.error = "false";
                    field.classList.remove('error');
                })
            })

            if(!inputChecked){
                errorDiv.innerHTML = errorDiv.dataset.errorRequired;
                errorDiv.dataset.error = 'true';
                field.classList.add('error')
            } else{
                errorDiv.innerHTML = "";
                errorDiv.dataset.error = 'false';
                field.classList.remove('error');
            }
        }

        function displayTextError(input, errorDiv, eventType){
            switch(input.getAttribute('type')){
                case 'text':
                    const regexFormatURL = /[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)?/gi;

                    const regexFormatUsername = /^([a-zA-Z0-9 _-]+)$/

                        if(input.name === "contact[company]") break;

                    
                        if(input.value.length === 0 && input.dataset.active !== 'false'){
                            errorDiv.innerHTML = errorDiv.dataset.errorRequired;
                            errorDiv.dataset.error = 'true';
                            input.dataset.error = 'true';
                        } 
                        else{
                            errorDiv.innerHTML = "";
                            errorDiv.dataset.error = 'false';
                            input.dataset.error = 'false';

                            if(input.id === "shopify-url"){
                                if(input.dataset.active === "true"){
                                    if(eventType === 'blur' && !input.value.match(regexFormatURL)){
                                        errorDiv.innerHTML = errorDiv.dataset.errorFormat;
                                        errorDiv.dataset.error = 'true';
                                        input.dataset.error = 'true';
                                    }
                                    else if(eventType === 'input' && input.value.match(regexFormatURL)){
                                        errorDiv.innerHTML = "";
                                        errorDiv.dataset.error = 'false';
                                        input.dataset.error = 'false';
                                    }
                                }
                            } 
                            else if(input.id === "username"){
                                if(eventType === 'blur'){
                                    if(input.value.length < 5){
                                        errorDiv.innerHTML = errorDiv.dataset.errorShort;
                                        errorDiv.dataset.error = 'true';
                                        input.dataset.error = 'true';

                                    } else if(input.value.length > 10){
                                        errorDiv.innerHTML = errorDiv.dataset.errorLong;
                                        errorDiv.dataset.error = 'true';
                                        input.dataset.error = 'true';

                                    } else if(!input.value.match(regexFormatUsername)){
                                        errorDiv.innerHTML = errorDiv.dataset.errorFormat;
                                        errorDiv.dataset.error = 'true';
                                        input.dataset.error = 'true';

                                    }
                                }
                                else if(eventType === 'input' && input.value.length > 5 && input.value.length < 10 && input.value.match(regexFormatUsername)){
                                    errorDiv.innerHTML = "";
                                    errorDiv.dataset.error = 'false';
                                    input.dataset.error = 'false';
                                }
                            }
                            else if(input.tagName === "TEXTAREA"){

                                if(eventType === 'blur' && input.value.length < 100){
                                    errorDiv.innerHTML = errorDiv.dataset.errorShort;
                                    errorDiv.dataset.error = 'true';
                                    input.dataset.error = 'true';
                                }
                                else if(eventType === 'input' && input.value.length >= 100){
                                    errorDiv.innerHTML = "";
                                    errorDiv.dataset.error = 'false';
                                    input.dataset.error = 'false';
                                }
                            }
                        }
                    break;

                case 'email':

                    const regexFormatEmail = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

                    if(input.value.length === 0){
                        errorDiv.innerHTML = errorDiv.dataset.errorRequired;
                        errorDiv.dataset.error = 'true';
                        input.dataset.error = 'true';
                    }
                    else{
                        if(!input.value.match(regexFormatEmail) && eventType === "blur"){
                            errorDiv.innerHTML = errorDiv.dataset.errorFormat;
                            errorDiv.dataset.error = 'true';
                            input.dataset.error = 'true';

                        } else if(input.value.match(regexFormatEmail) && eventType === "input"){
                            errorDiv.innerHTML = "";
                            errorDiv.dataset.error = 'false';
                            input.dataset.error = 'false';
                        }
                    }
                    break;
            }
        }

        // select custom NO CF (form when user connected)

        const fieldContainerUC = document.querySelector('.ct-field.deadline-choice-uc');

        initHtmlSelectCustomUC();

        function initHtmlSelectCustomUC(){
            const selectCustomContainer = fieldContainerUC.querySelector('.select-custom-container');
        
            const allOptions = document.querySelectorAll('.ct-field.deadline-choice-uc .cf-enum-field__choice');
        
            const titleFirst = fieldContainerUC.querySelector('.select-custom-title-first');

            titleFirst.addEventListener('click', () => {
                fieldContainerUC.classList.toggle('active');

                // titleFirst.classList.add('first-click');

                const titleFirstSpan = titleFirst.querySelector('span');
                let spanTitleFirstText;

                if(fieldContainerUC.classList.contains('active')){
                    spanTitleFirstText = customTitleFirst;
                } else{
                    if(selectCustomContainer.classList.contains('checked-within')){
                        const activeOptionText = document.querySelector('.ct-field.deadline-choice-uc .cf-enum-field__choice input:checked + span');

                        spanTitleFirstText = activeOptionText.innerText;
                    } else{
                        spanTitleFirstText = customTitleFirst;
                    }
                }

                titleFirstSpan.innerText = spanTitleFirstText;

            })

            for(option of allOptions){
                selectCustomContainer.appendChild(option);

                option.addEventListener('click', function(e){
                    if(e.target.type == 'radio'){

                        titleFirst.innerHTML = `<span>${e.target.value}</span><div class="svg-chevron"><svg xmlns="http://www.w3.org/2000/svg" width="16.943" height="11.3" viewBox="0 0 16.943 11.3">
                        <path id="Tracé_13893" data-name="Tracé 13893" d="M0,0,7.057,7.057,0,14.114" transform="translate(15.528 1.414) rotate(90)" fill="none" stroke="#65d09a" stroke-miterlimit="10" stroke-width="4"/>
                        </svg></div>`;
                        fieldContainerUC.classList.remove('active');

                        const fieldSet = document.querySelector('.ct-field.deadline-choice-uc fieldset');

                        fieldSet.classList.add('active');
                        selectCustomContainer.classList.add('checked-within');
                    }
                })
            }
        }
    }

    



    // other

    document.addEventListener('click', (e) => {

        var getParents = function (elem) {
      
          // Set up a parent array
          var parents = [];
        
          // Push each parent element to the array
          for ( ; elem && elem !== document; elem = elem.parentNode ) {
            parents.push(elem);
          }
        
          // Return our parent array
          return parents;
        
        };
      
        const allParents = getParents(e.target);
      
        if(!allParents.includes(document.querySelector('.cf-field-container.deadline-choice .cf-enum-field__choices'))){
            updateSelectCustomWhenClickOut(fieldContainer);
        }

        if(!allParents.includes(document.querySelector('.ct-field.deadline-choice-uc fieldset'))){
            if(!window.location.search.includes('?contact_posted=true')){
                const fieldContainerUC = document.querySelector('.ct-field.deadline-choice-uc');
                updateSelectCustomWhenClickOut(fieldContainerUC);
            }
        }

        function updateSelectCustomWhenClickOut(fieldContainer){
            fieldContainer.classList.remove('active');

            const selectCustomContainer = fieldContainer.querySelector('.select-custom-container');
        
            const titleFirst = fieldContainer.querySelector('.select-custom-title-first');

            const titleFirstSpan = titleFirst.querySelector('span');

            let spanTitleFirstText;

            if(selectCustomContainer.classList.contains('checked-within')){
                let activeOptionText;

                if(fieldContainer.dataset.cfFieldId === "110394"){
                    activeOptionText = document.querySelector('.cf-field.deadline-choice .cf-enum-field__choice input:checked + span');
                } else{
                    activeOptionText = document.querySelector('.ct-field.deadline-choice-uc .cf-enum-field__choice input:checked + span');
                }

                spanTitleFirstText = activeOptionText.innerText;
            } else{
                spanTitleFirstText = customTitleFirst;
            }

            titleFirstSpan.innerText = spanTitleFirstText;
        }
      
      })

      detectDeviceType();

      function detectDeviceType() {
        const userAgent = window.navigator.userAgent;
        const iOS = userAgent.match(/iPad/i) || userAgent.match(/iPhone/i);
    
        if (iOS) {
            const selectCustomContainers = document.querySelectorAll('.select-custom-container');
            
            selectCustomContainers.forEach(select => {
                select.classList.add('ios');
            })
            }
        }

    //   function detectDeviceType() {
    //     const userAgent = navigator.userAgent || navigator.vendor || window.opera;
  
    //     if (/iPad|iPhone|iPod|Macintosh/.test(userAgent) && !window.MSStream) {
    //         const selectCustomContainers = document.querySelectorAll('.select-custom-container');
            
    //         selectCustomContainers.forEach(select => {
    //             select.classList.add('ios');
    //         })
    //     }
  
    //   }


})

